// extracted by mini-css-extract-plugin
export var badge = "product-display-cards-gallery-module--badge--609b2";
export var card = "product-display-cards-gallery-module--card--55bd6";
export var cardInner = "product-display-cards-gallery-module--cardInner--56acc";
export var cardWrapper = "product-display-cards-gallery-module--cardWrapper--ca596";
export var containerWrapper = "product-display-cards-gallery-module--containerWrapper--87b40";
export var cta = "product-display-cards-gallery-module--cta--0f7a0";
export var description = "product-display-cards-gallery-module--description--14e94";
export var growTitle = "product-display-cards-gallery-module--growTitle--4a373";
export var headline = "product-display-cards-gallery-module--headline--d33bd";
export var showLessArrow = "product-display-cards-gallery-module--showLessArrow--c9089";
export var wrapper = "product-display-cards-gallery-module--wrapper--d8735";